export interface PrivacyLaw {
  id: string;
  name: string;
  category: 'global' | 'usFederal' | 'usState';
  description: string;
}

export const privacyLaws: PrivacyLaw[] = [
  // Global Privacy Laws
  {
    id: 'gdpr',
    name: 'GDPR (EU)',
    category: 'global',
    description: 'General Data Protection Regulation - Comprehensive data protection law in the EU'
  },
  {
    id: 'pipl',
    name: 'PIPL (China)',
    category: 'global',
    description: 'Personal Information Protection Law - China\'s data protection framework'
  },
  {
    id: 'lgpd',
    name: 'LGPD (Brazil)',
    category: 'global',
    description: 'Lei Geral de Proteção de Dados - Brazilian General Data Protection Law'
  },
  {
    id: 'pdpa_sg',
    name: 'PDPA (Singapore)',
    category: 'global',
    description: 'Personal Data Protection Act - Singapore\'s data protection framework'
  },
  {
    id: 'popia',
    name: 'POPIA (South Africa)',
    category: 'global',
    description: 'Protection of Personal Information Act - South Africa\'s privacy law'
  },

  // US Federal Laws
  {
    id: 'hipaa',
    name: 'HIPAA',
    category: 'usFederal',
    description: 'Health Insurance Portability and Accountability Act - Healthcare privacy'
  },
  {
    id: 'coppa',
    name: 'COPPA',
    category: 'usFederal',
    description: 'Children\'s Online Privacy Protection Act - Children\'s privacy online'
  },
  {
    id: 'glba',
    name: 'GLBA',
    category: 'usFederal',
    description: 'Gramm-Leach-Bliley Act - Financial privacy'
  },
  {
    id: 'fcra',
    name: 'FCRA',
    category: 'usFederal',
    description: 'Fair Credit Reporting Act - Consumer reporting privacy'
  },
  {
    id: 'ferpa',
    name: 'FERPA',
    category: 'usFederal',
    description: 'Family Educational Rights and Privacy Act - Educational privacy'
  },

  // US State Laws
  {
    id: 'ccpa',
    name: 'CCPA/CPRA (California)',
    category: 'usState',
    description: 'California Consumer Privacy Act/California Privacy Rights Act'
  },
  {
    id: 'vcdpa',
    name: 'VCDPA (Virginia)',
    category: 'usState',
    description: 'Virginia Consumer Data Protection Act'
  },
  {
    id: 'cpa',
    name: 'CPA (Colorado)',
    category: 'usState',
    description: 'Colorado Privacy Act'
  },
  {
    id: 'ctdpa',
    name: 'CTDPA (Connecticut)',
    category: 'usState',
    description: 'Connecticut Data Privacy Act'
  },
  {
    id: 'ucpa',
    name: 'UCPA (Utah)',
    category: 'usState',
    description: 'Utah Consumer Privacy Act'
  },
  {
    id: 'tdpa',
    name: 'TDPA (Texas)',
    category: 'usState',
    description: 'Texas Data Privacy Act'
  }
];